import React, { useRef } from "react";
import { ReadCSV } from "_core/utils/file";

// styles imports
import './CSVInput.scss';

export const CSVInput = (props) => {
	// Refオブジェクトを返す
	const fileInputRef = useRef(null);

	const handleClick = () => {
		if (fileInputRef.current) {
		  fileInputRef.current.click(); // ここで正しくfocus()を呼び出す
		}
	};

	const handleFileLoad = async (file) => {
		try {
			const csvArray = await ReadCSV(file);
			if (props.onLoad) {
				props.onLoad(csvArray); // 成功時に props.onLoad を呼び出す
			}
			fileInputRef.current.value = ""
		} catch (error) {
			console.error("CSV の読み込みに失敗しました:", error);
		}
	};

	return (
		<div className={"csv-input button padding-16px " + (props.className ? props.className : "")} onClick={handleClick} >
			<div className="flex flex-center">
				{props.children}
			</div>
			<input 
				ref={fileInputRef}
				type="file"  
				accept=".csv" 
				id="import-csv"
				// 現在は1ファイルのみ対応
				onChange={(e) => {handleFileLoad(e.target.files[0])}}
				content="text/html; charset=Shift_JIS"
				/>
		</div>
	);
}
export default CSVInput